import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout/Layout';
import AuthGuard from './components/AuthGuard/AuthGuard';
import ToastContainer from './components/common/Toast/ToastContainer';
import Login from './pages/Login/Login';
import LoadBacktest from './pages/LoadBacktest/LoadBacktest';
import RunBacktest from './pages/RunBacktest/RunBacktest';
import FetchData from './pages/FetchData/FetchData';
import ManualTrading from './pages/ManualTrading/ManualTrading';
import Configuration from './pages/Configuration/Configuration';
import Analytics from './pages/Analytics/Analytics';
import FundManagement from './pages/FundManagement/FundManagement';
import LiveMonitor from './pages/LiveMonitor/LiveMonitor';
import Historical from './pages/Historical/Historical';
import Advisor from './pages/Advisor/Advisor';
import LLM from './pages/LLM/LLM';
import TradingFloor from './pages/TradingFloor/TradingFloor';
import TradingFloorEmbed from './pages/TradingFloor/TradingFloorEmbed';
import './App.css';

function App() {
  return (
    <ThemeProvider>
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/floor-embed" element={<TradingFloorEmbed />} />
        <Route path="*" element={
          <AuthGuard>
            <Layout>
              <Routes>
                <Route path="/" element={<LoadBacktest />} />
                <Route path="/run-backtest" element={<RunBacktest />} />
                <Route path="/fetch-data" element={<FetchData />} />
                <Route path="/manual-trading" element={<ManualTrading />} />
                <Route path="/monitor" element={<LiveMonitor />} />
                <Route path="/historical" element={<Historical />} />
                <Route path="/advisor" element={<Advisor />} />
                <Route path="/llm" element={<LLM />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/fund" element={<FundManagement />} />
                <Route path="/configuration" element={<Configuration />} />
                <Route path="/trading-floor" element={<TradingFloor />} />
              </Routes>
            </Layout>
          </AuthGuard>
        } />
      </Routes>
      <ToastContainer />
    </Router>
    </ThemeProvider>
  );
}

export default App;
